package components

import it.neckar.react.common.*
import it.neckar.react.common.button.*
import react.*
import react.dom.*

/**
 * A heading with a spreadsheet-export button next to it, shared by every export action in the planner UI.
 */
fun RBuilder.exportHeading(title: String, buttonLabel: String = "Excel-Export", action: suspend () -> Unit) {
  div("d-flex justify-content-between align-items-center mb-2") {
    //The global h2 style has a top margin, which would push the title below the vertical center of the button
    h2("mt-0 mb-0") {
      +title
    }

    actionButton(
      icon = ButtonIconCentered(FontAwesomeIcons.Download),
      classes = "btn btn-outline-primary",
      action = action,
    ) {
      b("ms-2") {
        +buttonLabel
      }
    }
  }
}
